import { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Grid, Typography, Box, TextField, Tooltip, Zoom, IconButton } from '@material-ui/core';
import { MdOutlineUploadFile } from 'react-icons/md';
import { applicationContext } from 'helpers/services';
import { useHistory } from 'react-router-dom';
import { Dropzone } from 'components';
import { Alert, Autocomplete } from '@material-ui/lab';


interface IRequest {
    country: string
    filename: string
    formData?: FormData
}

let ExcelImport = () => {
    let history = useHistory();

    let appService = useContext(applicationContext);

    let [isOpen, setOpen] = useState(false);
    let [isSaving, setSaving] = useState(false);
    let [errorMessage, setErrorMessage] = useState('');
    let [searchCountry, setSearchCountry] = useState('');

    let initialState: IRequest = {
        country: '',
        filename: '',
        formData: undefined
    }

    let [importRequest, setImportRequest] = useState<IRequest>(initialState);

    useEffect(() => {
        setImportRequest({
            ...importRequest
        })
    }, [isOpen])

    let updateRequest = (newRequest: IRequest) => {
        setImportRequest(newRequest);
    }

    let saveImportRequest = async () => {
        if (importRequest.formData === undefined) {
            setErrorMessage("Excel file must be selected");
            return;
        }
        if (importRequest.country === '') {
            setErrorMessage("Country must be specified")
            return;
        }

        try {
            setSaving(true);

            importRequest.formData.append("country", importRequest.country);

            let res = await axios.post('/api/ExcelImport/SaveExcelImportRequest', importRequest.formData);
            history.push(`/excelimport/${res.data.id}`);
            setSaving(false);

        } catch (err) {
            setSaving(false);
        }
    }


    return (
        <>
            <Tooltip TransitionComponent={Zoom} title={'Import from Excel file'}>
                <IconButton size="small" onClick={() => setOpen(true)}>
                    <MdOutlineUploadFile size={24} />
                </IconButton>
            </Tooltip>

            <Dialog
                open={isOpen}
                maxWidth="md"
                fullWidth={true}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle disableTypography id="form-dialog-title">
                    <Typography variant="h2">
                        <Box fontWeight="fontWeightLight">
                            Excel import
                        </Box>
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography gutterBottom>Upload the file and choose a country to continue importing dealers.</Typography>
                    <Dropzone
                        onDropCallback={(acceptedFiles) => {
                            let file = acceptedFiles[0];

                            let data = new FormData();
                            data.append("file", file);

                            setImportRequest({
                                ...importRequest,
                                filename: file.name,
                                formData: data
                            })
                        }}
                        isMultiple={false}
                        accept=".xls, .xlsx"
                    />
                    <Typography gutterBottom>{importRequest.filename}</Typography>
                    <Typography gutterBottom>Import only dealers in country</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Autocomplete
                                size="small"
                                inputValue={searchCountry}
                                value={importRequest.country}
                                onInputChange={(event, newInputValue) => setSearchCountry(newInputValue)}
                                getOptionLabel={(option) => appService.referenceData.countries.getValueByKey(option)}
                                options={appService.referenceData.countries.map(x => x.key)}
                                onChange={(e, value) => updateRequest({ ...importRequest, country: value || '' })}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        fullWidth
                                        label="Country"
                                        variant="outlined"
                                    />
                                }
                            />
                        </Grid>
                        {errorMessage &&
                            <Grid item xs={12}>
                                <Alert severity="error">{errorMessage}</Alert>
                            </Grid>
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    {isSaving && <CircularProgress size={20} />}
                    <Button
                        onClick={() => {
                            setOpen(false);
                            setImportRequest(initialState);
                            setErrorMessage('');
                        }}
                        variant="outlined"
                        color="secondary"
                        disabled={isSaving}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={saveImportRequest}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ExcelImport;